import { render, staticRenderFns } from "./ProductorCourses.vue?vue&type=template&id=565efa6c"
import script from "./ProductorCourses.vue?vue&type=script&lang=js"
export * from "./ProductorCourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports